module.exports = __webpack_public_path__ + "static/media/Bird5.e3fdb263.jpg";